var geolocation = {
  DEFAULT_OPTIONS: {
    timeout: 20000
  },
  // onSuccess: callback called with object like {latitude: ..., longitude: ...}
  // onError: optional, callback arg. has the following props (similar to standard GeolocationPositionError,
  //   however there is no guarantee that the object comes from that api):
  //     code - error code
  //     PERMISSION_DENIED, POSITION_UNAVAILABLE, TIMEOUT - error constants
  //     message - user readable error message, MAY BE MISSING, but if present, can be used for debugging
  // options: optional, object, can specify following props:
  //     timeout -  milliseconds before error callback is invoked
  getCurrentPosition: function(onSuccess, onError, options) {
    if (typeof options == 'undefined') options = {};
    Object.assign(options, geolocation.DEFAULT_OPTIONS);
    window.navigator.geolocation.getCurrentPosition(
      function(position) { onSuccess({latitude: position.coords.latitude, longitude: position.coords.longitude}); },
      onError, options
    );
  },
  mapUrl: function(loc) {
    var dev = window.vueApp.$device;
    if (dev.cordova && dev.android) return 'geo:'+loc.latitude+','+loc.longitude;
    else if (dev.cordova && dev.ios) return 'http://maps.apple.com/?sll='+loc.latitude+','+loc.longitude
    else return 'https://maps.google.com/maps?q=loc:'+loc.latitude+','+loc.longitude;
  }
};

export default geolocation;
